import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertTriangle, Pencil, Check, Loader2 } from "lucide-react";
import { QUALITY_CHECK_LABELS } from "../lib/constants";

const bandColor = (s) => (s >= 90 ? "text-emerald-500" : s >= 70 ? "text-lime-500" : s >= 50 ? "text-amber-500" : "text-red-500");

export default function QualityWarningDialog({ data, onModifica, onSalvaComunque, saving }) {
  const q = (data && data.quality) || {};
  const mancanti = (q.mancanti || []).map((k) => QUALITY_CHECK_LABELS[k] || k);
  const suggeriti = mancanti.length ? mancanti : (data?.campi_suggeriti || []);
  return (
    <Dialog open={!!data} onOpenChange={(v) => { if (!v) onModifica(); }}>
      <DialogContent className="max-w-md" data-testid="quality-warning-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><AlertTriangle className="h-5 w-5 text-amber-500" /> Descrizione da migliorare</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className={`font-heading font-bold text-3xl leading-none ${bandColor(q.score)}`} data-testid="quality-score">
              {q.score}<span className="text-base text-muted-foreground">/100</span>
            </div>
            <div className="text-sm text-muted-foreground">{q.giudizio} · soglia minima {data?.soglia}</div>
          </div>
          <p className="text-sm">{data?.messaggio}</p>
          {suggeriti.length > 0 && (
            <ul className="text-sm space-y-1" data-testid="quality-suggestions">
              {suggeriti.map((m, i) => (
                <li key={i} className="flex items-start gap-2"><span className="text-amber-500 mt-0.5">•</span> {m}</li>
              ))}
            </ul>
          )}
          {q.suggerimento && <p className="text-xs text-muted-foreground border-l-2 border-amber-500/40 pl-3">{q.suggerimento}</p>}
          <div className="flex justify-end gap-2 pt-1">
            <Button variant="outline" onClick={onModifica} data-testid="quality-modifica-btn"><Pencil className="h-4 w-4 mr-1.5" /> Modifica</Button>
            {data?.can_override && (
              <Button onClick={onSalvaComunque} disabled={saving} data-testid="quality-salva-comunque-btn">
                {saving ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Check className="h-4 w-4 mr-1.5" />} Salva comunque
              </Button>
            )}
          </div>
          {!data?.can_override && <p className="text-[11px] text-muted-foreground text-center">Solo i ruoli autorizzati possono salvare senza migliorare la descrizione.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
